import { Instance } from 'mobx-state-tree';
import { ShopifyOrdersPageInfoDtoModelBase } from './ShopifyOrdersPageInfoDtoModel.base';

/* The TypeScript type of an instance of ShopifyOrdersPageInfoDtoModel */
export interface ShopifyOrdersPageInfoDtoModelType extends Instance<typeof ShopifyOrdersPageInfoDtoModel.Type> {}

/* A graphql query fragment builders for ShopifyOrdersPageInfoDtoModel */
export { selectFromShopifyOrdersPageInfoDto, shopifyOrdersPageInfoDtoModelPrimitives, ShopifyOrdersPageInfoDtoModelSelector } from './ShopifyOrdersPageInfoDtoModel.base';

/**
 * ShopifyOrdersPageInfoDtoModel
 */
export const ShopifyOrdersPageInfoDtoModel = ShopifyOrdersPageInfoDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
